"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const github = __importStar(require("@actions/github"));
const core = __importStar(require("@actions/core"));
const tc = __importStar(require("@actions/tool-cache"));
const utils_1 = require("./utils");
const fs_1 = require("fs");
const readline = __importStar(require("readline"));
const semver = __importStar(require("semver"));
function run() {
    return __awaiter(this, void 0, void 0, function* () {
        const checksumFilePath = process.argv.slice(2)[0];
        const defaultVersionFilePath = process.argv.slice(2)[1];
        const github_token = process.argv.slice(2)[2];
        const octokit = github.getOctokit(github_token);
        const response = yield octokit.paginate(octokit.rest.repos.listReleases, {
            owner: utils_1.OWNER,
            repo: utils_1.REPO
        });
        const downloadUrls = response.flatMap(release => release.assets
            .filter(asset => asset.name.endsWith('.sha256'))
            .map(asset => asset.browser_download_url));
        yield updateChecksums(checksumFilePath, downloadUrls);
        const latestVersion = response
            .map(release => release.tag_name)
            .sort(semver.rcompare)[0];
        core.setOutput('latest-version', latestVersion);
        yield updateDefaultVersion(defaultVersionFilePath, latestVersion);
    });
}
function updateChecksums(filePath, downloadUrls) {
    return __awaiter(this, void 0, void 0, function* () {
        yield fs_1.promises.rm(filePath);
        yield fs_1.promises.appendFile(filePath, '// AUTOGENERATED_DO_NOT_EDIT\nexport const KNOWN_CHECKSUMS: {[key: string]: string} = {\n');
        let firstLine = true;
        for (const downloadUrl of downloadUrls) {
            const content = yield downloadAsset(downloadUrl);
            const key = getKey(downloadUrl);
            if (!firstLine) {
                yield fs_1.promises.appendFile(filePath, ',\n');
            }
            yield fs_1.promises.appendFile(filePath, `  '${key}':\n    '${content.trim()}'`);
            firstLine = false;
        }
        yield fs_1.promises.appendFile(filePath, '}\n');
    });
}
function updateDefaultVersion(filePath, latestVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, e_1, _b, _c;
        const fileStream = (0, fs_1.createReadStream)(filePath);
        const rl = readline.createInterface({
            input: fileStream
        });
        let foundDescription = false;
        const lines = [];
        try {
            for (var _d = true, rl_1 = __asyncValues(rl), rl_1_1; rl_1_1 = yield rl_1.next(), _a = rl_1_1.done, !_a; _d = true) {
                _c = rl_1_1.value;
                _d = false;
                let line = _c;
                if (!foundDescription &&
                    line.includes("description: 'The version of rye to install'")) {
                    foundDescription = true;
                }
                else if (foundDescription && line.includes('default: ')) {
                    line = line.replace(/'[^']*'/, `'${latestVersion}'`);
                    foundDescription = false;
                }
                lines.push(line);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = rl_1.return)) yield _b.call(rl_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        yield fs_1.promises.writeFile(filePath, lines.join('\n'));
    });
}
function getKey(downloadUrl) {
    // https://github.com/astral-sh/rye/releases/download/0.4.0/rye-x86_64-windows.exe.sha256
    const parts = downloadUrl.split('/');
    const fileName = parts[parts.length - 1];
    const name = fileName.split('.')[0].split('rye-')[1];
    const version = parts[parts.length - 2];
    return `${name}-${version}`;
}
function downloadAsset(downloadUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const downloadPath = yield tc.downloadTool(downloadUrl);
        const content = yield fs_1.promises.readFile(downloadPath, 'utf8');
        return content;
    });
}
run();
